import { render, staticRenderFns } from "./TranscriptSummaryBox.vue?vue&type=template&id=7d81378c&scoped=true&"
import script from "./TranscriptSummaryBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./TranscriptSummaryBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TranscriptSummaryBox.vue?vue&type=style&index=0&id=7d81378c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d81378c",
  null
  
)

export default component.exports